import React from 'react';
import { MenuItemArgs } from './types';
import { IconDelete, IconEdit, IconPublish, IconAdd, IconView, IconClear, IconVariable } from './icons';
import { Poppins } from 'src/common';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';
import * as S from './util.styles';

export const VIEW = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="view">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:View',
        });
      }}
      onMouseEnter={() => setActiveItem('view')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-view"
    >
      <div className="icon-container">
        <IconView isActive={activeItem === 'view'} />
      </div>
      <Poppins px={16}>{label || 'View'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const PIN = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="pin">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: label === 'Unpin' ? 'Elipsis:Unpin' : 'Elipsis:Pin',
        });
      }}
      onMouseEnter={() => setActiveItem('pin')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-pin"
    >
      <div className="icon-container">
        <S.PinIcon sx={{ fontSize: 18 }} />
      </div>
      <Poppins px={16}>{label || 'Pin'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const CHANGE_PRIMARY_FRAMEWORK = ({
  label,
  exe,
  divider,
  resetActiveItem,
  activeItem,
  setActiveItem,
}: MenuItemArgs) => (
  <div key="change-primary-framework">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:ChangePrimaryFramework',
        });
      }}
      onMouseEnter={() => setActiveItem('change-primary-framework')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-change-primary-framework"
    >
      <div className="icon-container">
        <S.SwitchIcon sx={{ fontSize: 18 }} />
      </div>
      <Poppins px={16}>{label || 'Change primary framework'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const PUBLISH = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="publish">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:Publish',
        });
      }}
      onMouseEnter={() => setActiveItem('publish')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-publish"
    >
      <div className="icon-container">
        <IconPublish isActive={activeItem === 'publish'} />
      </div>
      <Poppins px={16}>{label || 'Publish'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const EDIT = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="edit">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:Edit',
        });
      }}
      onMouseEnter={() => setActiveItem('edit')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-edit"
    >
      <div className="icon-container">
        <IconEdit isActive={activeItem === 'edit'} />
      </div>
      <Poppins px={16}>{label || 'Edit'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const DELETE = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="delete">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:Delete',
        });
      }}
      onMouseEnter={() => setActiveItem('delete')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-delete"
    >
      <div className="icon-container">
        <IconDelete isActive={activeItem === 'delete'} />
      </div>
      <Poppins px={16}>{label || 'Delete'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const HIDE_CONTENT = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="hide-content">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:HideContent',
        });
      }}
      onMouseEnter={() => setActiveItem('hide-content')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-hide-content"
    >
      <div className="icon-container">
        <IconClear isActive={activeItem === 'hide-content'} />
      </div>
      <Poppins px={16}>{label || 'Hide content'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const VARIABLES = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="var">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:Variables',
        });
      }}
      onMouseEnter={() => setActiveItem('var')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-variables"
    >
      <div className="icon-container">
        <IconVariable isActive={activeItem === 'var'} />
      </div>
      <Poppins px={16}>{label || 'Variables'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const RISK_TOLERANCE = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="risk">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:RiskTolerance',
        });
      }}
      onMouseEnter={() => setActiveItem('risk')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-risk"
    >
      <div className="icon-container">
        <IconAdd isActive={activeItem === 'risk'} />
      </div>
      <Poppins px={16}>{label || 'Risk Tolerance'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);
